
























import Vue from 'vue';
import { mapState } from 'vuex';

import Section from '@/components/Bulma/Section.vue';
import Columns from '@/components/Bulma/Columns.vue';
import Column from '@/components/Bulma/Column.vue';
import ProductCard from '@/components/ProductCard.vue';
import SearchFilter from '@/components/SearchFilter.vue';

import Product from '@/types/Product';
import Tag from '@/types/Tag';
import FilterValue from '@/types/FilterValue';

import Util from '@/util/Util';

export default Vue.extend({
	name: 'Products',

	components: {
		Section,
		ProductCard,
		Columns,
		Column,
		SearchFilter
	},

    props: {
        query: Object
    },

	created() {
		const filter = new FilterValue();
		if (this.query.searchText) {
			filter.searchText = this.query.searchText;
		}
		filter.tagIds = this.query.tagIds;
		this.filter = filter;
		Util.updateHeaders((this as any).$text('products'), (this as any).$text('readProducts'), process.env.VUE_APP_DEFAULT_IMAGE);
	},

    data() {
        return {
			filter: new FilterValue()
        };
    },

	computed: {
		...mapState(['products', 'language'])
	},

	watch: {
		filter: {
			handler(value: FilterValue): void {
				const searchText = value.searchText;
				let query = {};
				if (value.searchText && value.tagIds && value.tagIds.length > 0) {
					query = { searchText, tagIds: value.tagIds.join(',') };
				} else if (value.searchText) {
					query = { searchText };
				} else if (value.tagIds && value.tagIds.length > 0) {
					query = { tagIds: value.tagIds.join(',') };
				}

				this.$router.push({ path: this.$route.path, query });
			},
			deep: true
		}
	},

	methods: {
		selectProduct(product: Product): void {
			this.$router.push({ name: 'product', params: { productId: product.productId } });
			setTimeout(() => { Util.scrollToElementWithId('product'); }, 250);
		},

		filterProducts(products: Product[], type: string): Product[] {
			return products
				.filter((product: Product) => product.productType === type)
				.filter((product: Product) => this.filter.tagIds.length === 0 || this.getProductTagIds(product).some((tagId: string) => this.filter.tagIds.includes(tagId)))
				.filter((product: Product) => this.filter.searchText === '' || (product.productName as any)[this.language].toLowerCase().includes(this.filter.searchText.toLowerCase()));
		},

		getProductTagIds(product: Product): string[] {
			if (product.tags && product.tags.length > 0) {
				return product.tags.map((tag: Tag) => tag.tagId);
			}
			return new Array<string>();
		}
	}
});
